import React from 'react';
import Image from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';

const VideoImg = () => {
  const data = useStaticQuery(graphql`
    {
      strapiHomePage {
        video_thumbnail {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `);

  const { strapiHomePage } = data;
  return (
    <>
      <Image
        fluid={strapiHomePage.video_thumbnail.childImageSharp.fluid}
        alt='thumnail'
      />
    </>
  );
};

export default VideoImg;
